<!-- ✅ Contenedor principal con botón de cierre -->
<div  class="close-button" (click)="onClose()">
  <i class="bi bi-x-lg"></i>
</div>

<!-- ✅ Vista cuando la firma se envía correctamente -->
<div *ngIf="isSuccses; else cameraTemplate" class="succses">
  <img src="assets/images/icons/check_blue.svg" class="img-fluid" alt="Check" />
  <h2>¡Listo!</h2>
  <p>Guía firmada exitosamente.</p>
</div>

<!-- ✅ Vista de la cámara -->
<ng-template #cameraTemplate>
  <h2 mat-dialog-title class="title">Apunta la cámara<br> sobre la firma</h2>

  <mat-dialog-content class="camera-container">
    <video #videoElement [hidden]="photoCaptured" autoplay playsinline></video>
    <canvas #canvasElement [hidden]="!photoCaptured"></canvas>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-raised-button
      color="primary"
      (click)="capturePhoto()"
      [disabled]="loading || photoCaptured"
    >
      {{ loading ? 'Enviando...' : 'Capturar' }}
    </button>
  </mat-dialog-actions>
</ng-template>


